import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import Page from "components/Page";
import SearchBar from "components/SearchBar";
import Spinner from "components/Spinner";
import Status from "components/Status";
import moment from "moment";
import { Link, useSearchParams } from "react-router-dom";
import { FETCH_POS } from "./graphql";
import { getOrderStatus, getReceiptStatus } from "./utils";

const DELIVERY_WARNING_DAYS = 7;

function getDeliveryDateWarning(po) {
  if (po.receipt_status === "full" || po.state === "draft") return null;

  const plannedDate = moment(po.date_planned).startOf("day");
  if (!plannedDate.isValid()) return null;

  const today = moment().startOf("day");
  const diffDays = plannedDate.diff(today, "days");

  if (diffDays < 0) {
    return { emoji: "🔴", className: "text-red-600 font-bold" };
  }

  if (diffDays <= DELIVERY_WARNING_DAYS) {
    return { emoji: "🟠", className: "text-orange-500 font-bold" };
  }

  return null;
}

const PurchaseOrdersPage = () => {
  const [searchParams, setSearchParams] = useSearchParams({ q: "" });
  const { loading, error, data } = useQuery(FETCH_POS, {
    fetchPolicy:
      process.env.NODE_ENV === "production" ? "network-only" : "cache-first",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const pos = JSON.parse(data.supplierPos);

  console.log("pos", pos);

  return (
    <Page title="Orders 订单">
      <div className="m-8 mb-0">
        <SearchBar
          placeholder="Search by order number or product name 根据订单号或产品名称搜索"
          value={searchParams.get("q") || ""}
          onChange={(text) => {
            setSearchParams((prev) => {
              const p = new URLSearchParams(prev);
              if (text.trim() === "") {
                p.delete("q");
              } else {
                p.set("q", text);
              }
              return p;
            });
          }}
        />
      </div>

      <div className="card m-8 mt-4 flex-1 flex flex-col overflow-auto p-0 rounded-xl">
        <div className="overflow-auto relative text-sm">
          <table>
            <thead>
              <tr>
                <th className="px-6">订单号</th>
                <th className="px-6">状态</th>
                <th className="px-6">交付状态</th>
                <th className="px-6">关联</th>
                <th className="px-6 text-right">创建日期</th>
                <th className="px-6 text-right">交付日期</th>
                <th className="px-6 text-right">总价</th>
              </tr>
            </thead>
            <tbody>
              {pos.map((po) => {
                const warning = getDeliveryDateWarning(po);
                return (
                  <tr key={po.id} className="border-y border-gray-100">
                    <td className="px-6">
                      <Link to={`${po.company_id.id}/${po.id}`}>{po.name}</Link>
                    </td>
                    <td className="px-6">
                      <Status status={getOrderStatus(po.state)} />
                    </td>
                    <td className="px-6">
                      <Status status={getReceiptStatus(po.receipt_status)} />
                    </td>
                    <td className="px-6">{po.so.display_name}</td>
                    <td className="px-6 text-right">
                      {moment(po.create_date).format("YYYY-MM-DD")}
                    </td>
                    <td
                      className={`px-6 text-right ${warning ? warning.className : ""}`}
                    >
                      {warning ? `${warning.emoji} ` : ""}
                      {moment(po.date_planned).format("YYYY-MM-DD")}
                    </td>
                    <td className="px-6 text-right">
                      {po.amount_total.toLocaleString(
                        {
                          style: "currency",
                          currency: po.currency_id.symbol,
                        },
                        { minimumFractionDigits: 2 },
                      )}
                      {po.currency_id.symbol}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Page>
  );
};

export default PurchaseOrdersPage;
